import React, { useState } from "react";
import OptionsAdmin from "./OptionsMenu/OptionsAdmin";
import MyAccounAdmin from "./MyAccount/MyAccountAdmin";
import SearchGlobalView from "./GlobalSearch/SearchGlobalView";
import AccountingDashboard from "./accounting/AccountingDashboard";
import PackageScanner from "./package-dashboard/scanner/PackageScanner";
import AdminPanel from "./chat/AdminPanel";
import AdminChats from "./chat-leads/AdminChats";
import SalesChatDashboard from "./chat-sales/SalesChatDashboard";
import AdminProvinciaDeliveries from "./ProvinciaManager/AdminProvinciaDeliveries";
import TorreDeControl from "./control-tower/TorreDeControl";
import { ExpressDashboard } from "./express/ExpressDashboard";
import AdminDocsManager from "./docs/AdminDocsManager";
import AdminDrivers from "./drivers/AdminDrivers";
import { PackageDashboard } from "./package-dashboard/PackageDashboard";
import AdminFeaturedAds from "./AdsManager/AdminFeaturedAds";
function MainAdmin({ user_id, username, onLogout, email, phone_number, onUpdateUser }) {
    const [activeComponent, setActiveComponent] = useState('OptionsAdmin');

    return (
        <div className="container-fluid p-0">
            {activeComponent === 'OptionsAdmin' && 
                <OptionsAdmin username={username} setActiveComponent={setActiveComponent} onLogout={onLogout} />
            }
            {activeComponent === 'MyAccountAdmin' &&
                <MyAccounAdmin onUpdateUser={onUpdateUser} userId={user_id} username={username} phoneNumber={phone_number} email={email} setActiveComponent={setActiveComponent} />
            }
            {activeComponent === 'SearchGlobal' &&

                <SearchGlobalView setActiveComponent={setActiveComponent}/>
            }
            {activeComponent === 'PackageScanner' && <PackageScanner setActiveComponent={setActiveComponent} userId={user_id}/>}
            {activeComponent === 'PackageDashboard' && <PackageDashboard setActiveComponent={setActiveComponent} userId={user_id}/>}
            {activeComponent === 'Chat' && <AdminPanel setActiveComponent={setActiveComponent} userId={user_id}/>}
            {activeComponent === 'Accounting' && <AccountingDashboard userId={user_id} setActiveComponent={setActiveComponent}/> }             
            {activeComponent === 'LeadsChat' && <AdminChats userId={user_id}/> } 
            {activeComponent === 'SalesChat' && <SalesChatDashboard setActiveComponent={setActiveComponent}/> }  
            {activeComponent === 'ProvinciaDeliveries' && <AdminProvinciaDeliveries setActiveComponent={setActiveComponent}/> }
            {activeComponent === 'ControlTower' && <TorreDeControl setActiveComponent={setActiveComponent}/> }
            {activeComponent === 'DocsManager' &&  <AdminDocsManager setActiveComponent={setActiveComponent} />}
            {activeComponent === 'Drivers' && <AdminDrivers setActiveComponent={setActiveComponent}/> }
            {activeComponent === 'ExpressDeliveries' && <ExpressDashboard user_id={user_id} setActiveComponent={setActiveComponent}/> }
            {activeComponent === 'AdminFeaturedAds' && <AdminFeaturedAds setActiveComponent={setActiveComponent}/> }
        </div>
    );
}

export default MainAdmin;
